import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalGenerateReviews from "./ModalGenerateReviews";

const useModalGenerateReviews = () =>
{
    const [dialog, setDialog]  = useState ( { openState: false, year_term_id: null, onSaveCompleted: null })   ;

    const onClick = ( year_term_id, onCompleteFunction ) =>
    {
        setDialog ({ openState: true, year_term_id: year_term_id, onSaveCompleted: onCompleteFunction });
    }

    const onCloseModal = () =>
    {
        // Tell the parent we're done
        if ( dialog.onSaveCompleted != null )
        {
            dialog.onSaveCompleted('cancel') ;
        }

        setDialog ({ openState: false, year_term_id: null, onSaveCompleted: null });
    };

    const onSaveComplete = () =>
    {
        // Tell the parent we're done
        if ( dialog.onSaveCompleted != null )
        {
            dialog.onSaveCompleted('saved') ;
        }

        // Close the dialog
        setDialog ({ openState: false, year_term_id: null, onSaveCompleted: null });

    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={false} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                <ModalGenerateReviews onSaveCompleted={onSaveComplete} onClose={onCloseModal} year_term_id={dialog.year_term_id} params={dialog} mode={dialog.mode} />
            </Modal>
        )
    }

    return [ render, onClick ] ;
}

export default useModalGenerateReviews ;
